export default "__VITE_ASSET__BbO8jK3r__"